import api from './api-caller';
import utils from '../mixins/utils';
const { getOrganizationPublicId } = utils.methods;

const baseEndpoint = '/organizations';

export default {
    upload: (params) => {
        try {
            let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/signed-urls/upload?name=${params.name}&fileName=${params.fileName}&fileType=${params.fileType}`;
            if (params.orgImage) {
                endpoint += "&orgImage=true"
            }
            return api(endpoint, 'GET')
        } catch (error) {
            throw error;
        }
    }
}
